export const SESSION_STORAGE_SHOW_AZURE_LOGIN = 'show.azure.login';
export const LOCAL_STORAGE_PB_USER_TOKEN = 'projectboard.user.token';
export const LOCAL_STORAGE_PB_USER_TOKEN_DATE = 'projectboard.user.token.date';
export const LOCAL_STORAGE_PB_USER_CLAIMS = 'projectboard.user.claims';
export const SUPERVISOR_REVIEW_LOOKBACK_YEARS = 6; //Supervisors can only view up to previous 6 years of pb data
export const LOCAL_STORAGE_PB_SERVER_VERSION = 'projectboard.server.version';
export const LOCAL_STORAGE_PB_UI_VERSION = 'projectboard.ui.version';